import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../App.css';
import dairyLinkLogo from '../../Assets/Images/DairyLink-logo.svg';

const resetBrandTheme = () => {
  document.documentElement.style.setProperty('--brand-color', '#0f3d9a');
  document.documentElement.style.setProperty('--brand-secondary-color', '#4f6bd7');
  document.documentElement.style.setProperty('--brand-active-text-color', '#14223a');
  document.documentElement.style.setProperty('--secondary-color', '#4f6bd7');
  document.documentElement.style.setProperty('--active-text-color', '#14223a');
};

const DashLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  React.useEffect(() => {
    resetBrandTheme();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    setSubmitting(true);
    setError('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASEURL}/api/login`, {
        email,
        password
      });

      localStorage.setItem('udsAdminToken', response.data.token);
      navigate('/dashboard/instances');
    } catch (err) {
      setError('Invalid credentials, please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-brand">
        <img src={dairyLinkLogo} alt="DairyLink" />
      </div>

      <div className="auth-card">
        <div className="auth-card__header">
          <h1>Admin Hub</h1>
          <p>Sign in to configure tenants and manage operations.</p>
        </div>

        <form onSubmit={handleSubmit}>
          {error && <div className="alert error">{error}</div>}

          <div className="form-field">
            <label htmlFor="admin-email">Email</label>
            <div className="form-field-control">
              <input
                type="email"
                id="admin-email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-field">
            <label htmlFor="admin-password">Password</label>
            <div className="form-field-control">
              <input
                type="password"
                id="admin-password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
          </div>

          <button type="submit" className="button" disabled={submitting}>
            {submitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default DashLogin;
